import axiosInstance from './config/api';

export type CommunicationMedium = 'CALL' | 'SMS' | 'BOTH';

export type PhoneNumberLifecycleStatus =
    | 'PURCHASED'
    | 'REGISTERING'
    | 'PENDING_PROPAGATION'
    | 'WARMUP_T1'
    | 'WARMUP_T2'
    | 'WARMUP_T3'
    | 'WARMUP_T4'
    | 'WARMUP_T5'
    | 'ACTIVE'
    | 'QUARANTINED'
    | 'RELEASED';

export type WorkflowPhoneNumber = {
    id: string;
    phoneNumber: string;
    outboundTrunkSid: string;
    provider: string;
    communicationMedium: CommunicationMedium;
    lifecycleStatus?: PhoneNumberLifecycleStatus | string;
    lifecycleEnteredAt?: string;
    dialable?: boolean;
    dailyCallCap?: number;
    /** True when the workflow skips warm-up and the number is not yet ACTIVE. */
    warmupSkipped?: boolean;
};

export type WorkflowPhoneNumbersParams = {
    workflowId: string;
    currentPage?: number;
    perPage?: number;
};

export type WorkflowPhoneNumbersResponse = {
    data: WorkflowPhoneNumber[];
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export const getWorkflowPhoneNumbers = async (params: WorkflowPhoneNumbersParams) => {
    const { data } = await axiosInstance.get<WorkflowPhoneNumbersResponse>('/telephony/workflow-phone-numbers', {
        params,
    });
    return data;
};
